module.exports = __webpack_public_path__ + "img/side-icon-55.4da79660.svg";